module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/FREE_EXPERIENCE.fe09b993.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/FREE_EXPERIENCE.png
// module id = 1156
// module chunks = 16